import { useUserGroups as useUserGroupsContext } from '../contexts/UserGroupsContext';

export function useUserGroups() {
  return useUserGroupsContext();
}
